exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Li-IWGcNyk_BQs5gAI9J0{margin-top:8px}", ""]);

// exports
exports.locals = {
	"tokenNewNameLabel": "_3Li-IWGcNyk_BQs5gAI9J0"
};